export class Dashboard {
  id!: number;
  name!: string;
  enabled!: boolean;
  defaultDashboard!: boolean;
}
